import React, { ReactNode } from 'react';
import { useAuth } from 'src/components/AuthProvider/AuthProvider';
import { SimpleDialog } from 'src/components/SimpleDialog/SimpleDialog';
import { getWindow } from 'src/utilities/window';

interface IAuthErrorWrapperProps {
  children: ReactNode;
}

export const AuthErrorWrapper = ({
  children,
}: IAuthErrorWrapperProps): JSX.Element => {
  const { hasAuthError } = useAuth();
  const window = getWindow();
  const reload = () => window.location.reload();
  const redirectToGrubhubHomepage = () => {
    window.location.href = window.location.origin;
  };

  return (
    <>
      {hasAuthError ? (
        <SimpleDialog
          title="Oops, something went wrong!"
          description="An error occurred while loading the page."
          onPrimaryActionClick={reload}
          primaryActionText="Try again"
          secondaryActionText="Go to Grubhub home"
          onSecondaryActionClick={redirectToGrubhubHomepage}
          secondaryButtonVariant="tertiary"
          buttonsDirection="column"
        />
      ) : (
        children
      )}
    </>
  );
};

export default AuthErrorWrapper;
